import { render, staticRenderFns } from "./GeneratePaySlip.vue?vue&type=template&id=5e8d0af2&"
import script from "./GeneratePaySlip.vue?vue&type=script&lang=js&"
export * from "./GeneratePaySlip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports